export default __webpack_public_path__ + "a256a7683fd64150a4fa17287afc7187.png";